import { apiCall, apiCallAdmin } from "../../services/api-service";

export const getDeviceListApi = async (params) => {
  const response = await apiCall("GET", `device?${params}`);
  return response;
};

export const getDeviceApi = async (id) => {
  const response = await apiCall("GET", `device/${id}`);
  return response;
};

export const getUserApi = async (term) => {
  const response = await apiCallAdmin("GET", `employee/autocomplete?term=${term}`);
  return response;
};

export const saveDeviceApi = async (body) => {
  const response = await apiCall("POST", "device", body);
  return response;
};

export const updateDeviceApi = async (body, id) => {
  const response = await apiCall("PUT", `device/${id}`, body);
  return response;
};

export const getDeptApi = async (term) => {
  const response = await apiCallAdmin("GET", `get_department?term=${term}`);
  return response;
};

export const getLocationApi = async (term) => {
  const response = await apiCallAdmin("GET", `get_location?term=${term}`);
  return response;
};
